import React, { Fragment } from 'react';

import Home from './Home/Home';
import About from './About/About';

import About2 from './About/About2';
import About3 from './About/About3';
import About4 from './About/About4';
import About5 from './About/About5';
import About6 from './About/About6';
import About62 from './About/About6 copy';
import Service from './Service/Service';
import Facts from './Facts/Facts';
import Blog from './Blog/Blog';
import Contact from './Contact/Contact';
import MapMarker from './MapMarker/MapMarker';

const sections = () => {
  return (
    <Fragment>
      <Home />

    

      
     
      <Blog />
      <Facts />
      
      <About62 />
      
      
    
    </Fragment>
  );
};

export default sections;
